import { LocationSelectionModalScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <LocationSelectionModalScreen />;
}
